<template>
  <div>
    <!-- Modal bookModal -->
    <div class="modal fade text-left text-black" ref="callToBookModal" tabindex="-1" aria-labelledby="bookingLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">

          <div class="modal-header">
            <h4 class="modal-title heading" id="bookingLabel">{{ location.booking_options.c2b_modal_title }}</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="row mb-2">
              <div class="col">
                <h2 class="mb-2" v-html="location.booking_options.c2b_message"></h2>
                <h3 class="mb-2" v-if="location.booking_options.c2b_show_telephone">Our number is <a :href="'tel:' + location.telephone">{{ location.telephone }}</a></h3>
                <h3 class="mb-2" v-if="location.booking_options.c2b_show_email">Our email address is <a :href="'mailto:' + location.email">{{ location.email }}</a></h3>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal" id="diffSlot">
              <span>Try another booking slot</span>
            </button>
            <button type="button" class="btn btn-primary" @click="contactPageClick()">
              Go To Contact Page
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- .modal callToBookModal -->

  </div>
</template>

<script>
import {Address} from 'address-rfc2821';

export default {
  props: {
    location: {
      type: Object,
      required: true,
    },
    brand: {
      type: String,
    },
  },

  data() {
    return {

    };
  },

  computed: {

  },

  methods: {
    showModal() {
      // console.log('showModal()');
      // Do any prep before showing the modal

      $(this.$refs.callToBookModal).modal('handleUpdate');
      $(this.$refs.callToBookModal).modal('show');
    },

    contactPageClick() {
      return window.location.href = this.location.locationContactHref;
    },

  },

  mounted() {

  },
}
</script>
